const NAME = "CONSENT_PUBLICATION";

export default NAME;
